import useAlert from '@/components/Alert/hooks/useAlert'
import createAffiliate from '../repository/createAffiliate'
import SignUpFormValues from '../types/SignUpFormValues'
import { useRedirect } from 'react-admin'
import Storage from '@/lib/Storage'

const SUCCESS_REDIRECT = '/login'
const SUCCESS_MESSAGE = 'Affiliate account created successfully!'

const useAffiliates = () => {
  const { getRecaptchaToken } = Storage()
  const { alertError, alertSuccess } = useAlert()

  const redirect = useRedirect()

  const signUp = async (values: SignUpFormValues) => {
    const recaptchaToken = getRecaptchaToken() || ''

    await createAffiliate(values, recaptchaToken)
      .then(() => {
        alertSuccess(SUCCESS_MESSAGE)
        redirect(SUCCESS_REDIRECT)
      })
      .catch(({ message }) => alertError(message))
  }

  return {
    signUp
  }
}

export default useAffiliates
